require('./avatarPicker.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
const classNames = require('classnames');
const Avatar = require('components/avatar/avatar');
const AvatarCreator = require('components/avatarCreator/avatarCreator');
const AvatarEditorModal = require('components/myProfile/avatarEditorModal/avatarEditorModal');
const UploadImageButton = require('components/myProfile/uploadImageButton/uploadImageButton');

class AvatarPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.selectedAvatar
        };
        this.handleAvatarChange = this.handleAvatarChange.bind(this);
        this.handleDrawingChange = this.handleDrawingChange.bind(this);
        this.setImageUrl = this.setImageUrl.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ value: nextProps.value });
    }

    setImageUrl(imageUrl) {
        const {
            onChangeModal,
            openModal
        } = this.props;
        this.setState({ imageUrl });
        !openModal && onChangeModal();
    }

    buildAvatarContent() {
        const selectedAvatar = this.props.selectedAvatar;

        return this.props.avatars.map(function(avatar) {
            const profileImgDescription = formatText('imgDescription-profile');
            const selected = selectedAvatar === avatar.url;
            const newId = `avatar-${avatar.value}`;

            let handleAvatarClick = () => {
                this.handleAvatarChange({
                    value: avatar.value,
                    url: avatar.url,
                    id: newId
                });
            };
            return (
                <li onClick={handleAvatarClick}
                    key={avatar.value}
                    className={classNames({
                        'avatar-picker__content avatar-picker__content--selected': selected,
                        'avatar-picker__content avatar-picker__content--unselected': !selected
                    })}
                >
                    <Avatar
                        imgType="small"
                        imgUrl={avatar.url}
                        imgDescription={profileImgDescription}
                        id={newId}
                    />
                </li>
            )
        }, this);
    }

    handleAvatarChange(value) {
        const {
            onAvatarChange,
            setProfileAvatarEditorError
        } = this.props;
        setProfileAvatarEditorError(false);
        this.setState({ value });
        onAvatarChange(value);
    }

    handleDrawingChange(value) {
        this.handleAvatarChange({ drawUrl: value });
    }

    render() {
        const {
            onAvatarChange,
            onChangeModal,
            openModal,
            setProfileAvatarEditorError
        } = this.props;
        const { imageUrl } = this.state;

        return (
            <section className="avatar-picker">
                <AvatarEditorModal
                    onAvatarChange={onAvatarChange}
                    onChangeModal={onChangeModal}
                    openModal={openModal}
                    setProfileAvatarEditorError={setProfileAvatarEditorError}
                    setImageUrl={this.setImageUrl}
                    uplodadedAvatar={imageUrl}
                />
                <div className="row">
                    <div className="avatar-picker__creator col-xs-6">
                        <div className="avatar-picker__element-container">
                            <AvatarCreator onSave={this.handleDrawingChange}/>
                        </div>
                    </div>
                    <div className="col-xs-6">
                        <div className="avatar-picker__element-container">
                            <UploadImageButton
                                label="avatarPicker-uploadImageButtonLabel"
                                setImageUrl={this.setImageUrl}
                                setProfileAvatarEditorError={setProfileAvatarEditorError}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="avatar-picker__creator col-xs-12">
                        <div className="avatar-picker__element-container">
                            <FormattedText className="avatar-picker__select-label" value="avatarPicker-selectAvatarLabel" />
                            <ul className="avatar-picker__container">
                                {this.buildAvatarContent()}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

AvatarPicker.defaultProps = {
    defaultValue: 'default',
    selectedAvatar : '',
    openModal: false
};

AvatarPicker.propTypes = {
    openModal: PropTypes.bool.isRequired,
    defaultValue: PropTypes.string,
    avatars: PropTypes.array.isRequired,
    onAvatarChange: PropTypes.func.isRequired,
    onChangeModal: PropTypes.func.isRequired,
    value: PropTypes.string,
    selectedAvatar: PropTypes.string,
    setProfileAvatarEditorError: PropTypes.func,
    uplodadedAvatar: PropTypes.string
};

module.exports = AvatarPicker;
